import styled from '@emotion/styled'
import { Button, Input, Radio } from 'antd'

export const Container = styled('div')`
  padding-bottom: 16px;
`

export const Top = styled('div')`
  display: flex;
  margin-bottom: 16px;
`

export const Bottom = styled('div')`
  display: flex;
`

export const NbContainer = styled('div')`
  border-radius: 50%;
  background-color: #e6f6ea;
  width: 28px;
  height: 28px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`

export const NumberBadge = styled('div')`
  color: #009640;
  font-size: 18px;
  font-weight: 400;
  position: absolute;
`

export const TContainer = styled('div')``

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  color: #000000;
`

export const SubTitle = styled('div')`
  font-size: 14px;
  font-weight: 400;
  color: #666666;
`
export const GreenButton = styled(Button)`
  background-color: #009640;
  border-color: #009640;
  color: white;

  &:focus {
    background-color: #007a30;
    border-color: #007a30;
  }
`

export const Field = styled(Input)`
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  padding: 0 12px;
  font-size: 14px;
  color: #000000;
  outline: none;
  margin-right: 8px;

  &:focus {
    border-color: #009640;
  }
`

export const FieldContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

export const OptionTitle = styled('div')`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 8px;
`

export const RadioGroup = styled(Radio.Group)`
  .ant-radio {
    align-self: start;
    padding-top: 4px;
  }
`
